module.exports = __webpack_public_path__ + "media/60.56c83e31.mp3";